import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Button } from '@mui/material';
import classNames from 'classnames';
import css from './MediaDataGrid.module.scss';

interface FilterButtonProps {
  activeFilterCount: number;
  isOpen: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const FilterButton = ({ activeFilterCount, isOpen, onClick }: FilterButtonProps) => {
  return (
    <Button
      className={classNames(css.filtersButton, {
        [css.filtersButtonActive]: activeFilterCount > 0,
        [css.filtersButtonOpen]: isOpen,
      })}
      startIcon={<FilterAltIcon />}
      onClick={onClick}
    >
      Filters
      {activeFilterCount > 0 && <span className={css.filterCountBadge}>{activeFilterCount}</span>}
    </Button>
  );
};
